<template>
    <div v-if="!isDisabled" class="d-flex justify-content-center" style="padding-top: 20px">
        <vue-recaptcha
            ref="recaptcha"
            sitekey="6LfiMpcpAAAAAF6KwaWss0KSnoBM5NaS-4cj2bxV"
            :load-recaptcha-script="true"
            @verify="emitVerifyEvent"
            @expired="emitExpiredEvent"
        ></vue-recaptcha>
        <p v-show="!validRecaptcha" class="v-messages error--text">Please complete the recaptcha</p>
    </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
export default {
    components: { VueRecaptcha },
    props: {
        validRecaptcha: {
            type: Boolean,
            required: true,
            default: true,
        },
        isDisabled: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    methods: {
        emitVerifyEvent(response) {
            this.$emit('verify', response);
        },
        emitExpiredEvent() {
            this.$emit('expired');
        },
    },
};
</script>
